import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M9.848 10.571c.58 0 1.05.429 1.04.953 0 .524-.459.952-1.04.952-.571 0-1.042-.428-1.042-.952s.46-.953 1.042-.953Zm3.724 0c.581 0 1.04.429 1.04.953s-.459.952-1.04.952c-.571 0-1.04-.428-1.04-.952s.458-.953 1.04-.953ZM18.378 2a2.05 2.05 0 0 1 2.041 2.06V22l-2.14-1.9-1.204-1.12-1.275-1.19.529 1.85H5.04A2.05 2.05 0 0 1 3 17.58V4.06C3 2.92 3.915 2 5.041 2h13.337Zm-3.841 13.06c2.2-.07 3.046-1.52 3.046-1.52 0-3.22-1.434-5.83-1.434-5.83-1.433-1.08-2.797-1.05-2.797-1.05l-.14.16c1.693.52 2.479 1.27 2.479 1.27a8.087 8.087 0 0 0-5.006-.94c-.06 0-.11.01-.17.02-.348.03-1.195.16-2.26.63-.367.17-.587.29-.587.29s.827-.79 2.618-1.31l-.1-.12S8.824 6.63 7.39 7.71c0 0-1.434 2.61-1.434 5.83 0 0 .837 1.45 3.036 1.52 0 0 .368-.45.668-.83-1.265-.38-1.742-1.18-1.742-1.18s.099.07.278.17c.01.01.02.02.04.03.03.02.06.03.09.05.248.14.497.25.725.34.409.16.896.32 1.464.43a6.94 6.94 0 0 0 2.579.01c.496-.087.98-.231 1.443-.43a5.69 5.69 0 0 0 1.144-.59s-.497.82-1.802 1.19c.3.38.658.81.658.81Z",
        }),
      ]
    )
  );
}
